<script>
import { required } from "vuelidate/lib/validators";
export default {
    name: "OPCRModal",
    props: {
        modalTitle: {
            type: String,
            default: "OPCR Details",
        },
    },
    data() {
        return {
            submitted: false,
            form: {
                id: 0,
                title: "",
                isSupplemental: false,
            }
        };
    },
    validations: {
        form: {
            title: { required },
        }
    },
    methods: {
        resetForm() {
            this.submitted = false;
            this.form = {
                id: 0,
                title: "",
                isSupplemental: false,
            };
        },
        updateForm(data) {
            this.form = JSON.parse(JSON.stringify(data));
        },
        submitForm() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            this.$emit('submit', JSON.parse(JSON.stringify(this.form)));
        }
    }
}
</script>
<template>
    <b-modal
        id="opcr-modal"
        :title="modalTitle"
        size="md"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="submitForm">
            <div class="mb-3">
                <label class="form-label">Title</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="form.title"
                />
            </div>
            <div
                class="
                    form-check
                    form-checkbox-outline
                    form-check-success
                    mb-3
                "
            >
                <input
                    type="checkbox"
                    :id="`isSupplemental`"
                    checked="checked"
                    class="
                        form-check-input
                    "
                    v-model="
                        form.isSupplemental
                    "
                /><label
                    :for="`isSupplemental`"
                    class="
                        form-check-label
                    "
                >
                    <h5
                        class="
                            text-dark
                            mb-0
                        "
                    >
                        Supplemental
                    </h5>
                </label>
            </div>
            <div class="modal-footer">
                <button
                    type="submit"
                    class="
                        btn btn-primary
                    "
                >
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('opcr-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>